/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql.generated'

const defaultOptions = {} as const
export type GetUncancelledInProgramCallsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetUncancelledInProgramCallsQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    inProgramVideoCallBookingInformation?: {
      __typename?: 'InProgramVideoCallBookingInformation'
      uncancelledCalls: Array<{
        __typename?: 'VideoCall'
        id: string
        startTime: Date
        endTime: Date
        checkInCallPatientHistoryEntryID?: string | null
      }>
    } | null
  }
}

export const GetUncancelledInProgramCallsDocument = gql`
  query getUncancelledInProgramCalls($uid: ID!) {
    patient(uid: $uid) {
      inProgramVideoCallBookingInformation {
        uncancelledCalls {
          id
          startTime
          endTime
          checkInCallPatientHistoryEntryID
        }
      }
    }
  }
`

/**
 * __useGetUncancelledInProgramCallsQuery__
 *
 * To run a query within a React component, call `useGetUncancelledInProgramCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUncancelledInProgramCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUncancelledInProgramCallsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetUncancelledInProgramCallsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUncancelledInProgramCallsQuery, GetUncancelledInProgramCallsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUncancelledInProgramCallsQuery, GetUncancelledInProgramCallsQueryVariables>(
    GetUncancelledInProgramCallsDocument,
    options
  )
}
export function useGetUncancelledInProgramCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUncancelledInProgramCallsQuery,
    GetUncancelledInProgramCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUncancelledInProgramCallsQuery, GetUncancelledInProgramCallsQueryVariables>(
    GetUncancelledInProgramCallsDocument,
    options
  )
}
export type GetUncancelledInProgramCallsQueryHookResult = ReturnType<typeof useGetUncancelledInProgramCallsQuery>
export type GetUncancelledInProgramCallsLazyQueryHookResult = ReturnType<
  typeof useGetUncancelledInProgramCallsLazyQuery
>
export type GetUncancelledInProgramCallsQueryResult = Apollo.QueryResult<
  GetUncancelledInProgramCallsQuery,
  GetUncancelledInProgramCallsQueryVariables
>
